import {
  inject,
  observer,
} from 'mobx-react';
import {
  WithSnackbarProps,
} from 'notistack';
import React, {
  Component,
} from 'react';
import GeneralTableComponent from '../../components/GeneralCRUDComponent/GeneralTableComponent/GeneralTableComponent';
import {
  TableCellTypes,
} from '../../components/GeneralCRUDComponent/TableCellTypes/TableCellTypes';
import {
  translate,
} from '../../helperFunctions/translation';
import {
  CountryStore,
} from '../../mobx-store/stores/countryStore';
import { AuthStore } from '../../mobx-store/stores/authStore';
import { IGateStore } from './../../mobx-store/storeInterfaces/gateStoreInterface';
import SnackBarComponent from '../../components/SnackBarComponent/SnackBarComponent';

interface IProps extends WithSnackbarProps {
  gateStore: IGateStore;
  countryStore: CountryStore;
  authStore: AuthStore;
  match: any;
  history: any;
  location: any;
}

interface IState {

}

@inject('gateStore')
@inject('countryStore')
@inject('authStore')
@observer
class Gates extends Component<IProps, IState> {
  addButton: any;

  tableHeader: any = [];

  tableCellTypes: TableCellTypes[] = [];

  title: string = translate('gatesListPageTitle', {});

  constructor(props: IProps) {
    super(props);
  }

  handleTableButtonCellClicked = (index: number, key: string) => {
    this.props.history.push(`/gates/${this.props.gateStore.gatesList[index].gateId}/edit`);
  };

  handelAdd = (): void => {
    this.props.history.push(`/gates/new`);
  };

  getAddBranchButton = () => ({
    title: 'Add',
    onAdd: this.handelAdd,
  });

  getGatesTableHeader = () => {
    const headers = [
      {
        title: translate('gatesListFacilityColumnTitle', {}),
      },
      {
        title: 'Active',
      }, {
        title: translate('gatesListBranchColumnTitle', {}),
      },
      {
        title: translate('gatesListEditColumnTitle', {}),
      }
    ];

    return headers;
  }

  getGatesTableCellTypes = (): TableCellTypes[] => {
    const cellTypes: TableCellTypes[] = [
      {
        cellType: 'Text',
        key: 'title',
      },
      {
        cellType: 'ToggleButton',
        key: 'isActive',
        activeLabel: 'Active',
        inactiveLabel: 'Not active',
        onChange: this.handleTableToggleCellChange,
      },
      {
        cellType: 'Text',
        key: 'branch',
      },
      {
        cellType: 'Button',
        key: 'edit',
        onClick: this.handleTableButtonCellClicked,
      },
    ];

    return cellTypes;
  }

  handleTableToggleCellChange = (index: number, key: string, value: boolean) => {
    this.props.gateStore.updateGateStatus(value, index)
      .then(() => {
        SnackBarComponent.getInstance().openSnackbar(translate('updatedMessage', {
        }), 8000, 'success');
      })
      .catch((error: any) => {
        SnackBarComponent.getInstance().openSnackbar(translate('errorMessage', {
        }), 8000, 'error');
      });
  };

  initTable = () => {
    this.addButton = this.getAddBranchButton();
    this.tableHeader = this.getGatesTableHeader();
    this.tableCellTypes = this.getGatesTableCellTypes();
  };

  getTableData = () => {

    return this.props.gateStore.gatesList.map(item => {

      return {...item, edit: 'Edit'}
    })
  }

  render() {
    this.initTable();
    return (
      <div>
        <GeneralTableComponent
          emptyMessage={translate('gatesListNoGatesMessage', {
          })}
          title={this.title}
          tableHeader={this.tableHeader}
          tableData={this.getTableData()}
          tableCellTypes={this.tableCellTypes}
          addButton={this.addButton}
          loadingStatus={[
            this.props.countryStore.getManagedCountriesRequestStatus,
            this.props.gateStore.getBranchesGatesRequestStatus
          ]}
        />
      </div>
    );
  }


  async componentDidMount() {
    const {
      countryStore,
      gateStore,
    } = this.props;

    await countryStore.getUserManagedCountries();

    gateStore.getGates(countryStore.managedCountries, 'en');
  }

}

export default Gates;
